module.exports = __webpack_public_path__ + "static/img/far3_active.78830a2a.png";